// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gp-0";
export var headerCellHover = "_gp-1";
export var readCellContainer = "_gp-2";
export var unreadIndicator = "_gp-3";